import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

interface LoaderProps {
  isLoading: boolean;
  message?: string | React.ReactNode;
}

const Loader: React.FC<LoaderProps> = ({ isLoading, message }) =>
  isLoading ? (
    <Box
      data-testid="loader"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'rgba(255, 255, 255, 0.8)',
      }}
    >
      <CircularProgress color="primary" />
      {message && <Box sx={{ mt: 2 }}>{message}</Box>}
    </Box>
  ) : null;

export default Loader;
